import { render } from "./InstructorPage.vue?vue&type=template&id=3092b48a&ts=true"
import script from "./InstructorPage.vue?vue&type=script&lang=ts"
export * from "./InstructorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__